module.exports = __webpack_public_path__ + "media/images/client-logos/client-logo_esssuper-e6f9c69c7d5987d0ae4ddae4ed9949c8.png";